import { render } from "./VectorIcon.vue?vue&type=template&id=783130c2"
import script from "./VectorIcon.vue?vue&type=script&lang=js"
export * from "./VectorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__